// 封装fetch方法，用于主域名检测
const fetchRequest = (url: string, options: object, timeout: number = 10000) => {
    const controller = new AbortController();
    const { signal } = controller;

    // 超时取消请求
    const timeId = setTimeout(() => {
        controller.abort();
    }, timeout)

    return fetch(url, {...options, signal})
    .then(response => {
        clearTimeout(timeId);
        return response
    })
    .catch((error) => {
        clearTimeout(timeId);
        if (error.name === 'AbortError') {
            throw new Error('Request timed out');
        }
        throw error;
    })
}

export {
    fetchRequest,
}